export default "__VITE_ASSET__Ckg5MYfd__"